module.exports = "https://deal-img.imgix.net/consumer/modern/cancun.cc7df25c.jpg";